"use client"

import { Switch } from "./ui/switch"

export function Switcher({ id, checked, onCheckChange }: { id: string; checked: boolean; onCheckChange: (id: string, checked: boolean) => void }) {
		function doCheckChange(checked: boolean) {
			onCheckChange(id, checked)
		}
		return (
			<Switch 
				checked={checked} 
				onCheckedChange={doCheckChange} 
				className="shadow-none align-middle data-[state=checked]:bg-(--theme-text) data-[state=unchecked]:bg-(--theme-text-muted)" 
			/>
		)
}
